import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';

const PERKS = [
  { icon: 'Calendar', text: 'Flexible recurring delivery days' },
  { icon: 'Users',    text: 'Group ordering for your whole team' },
  { icon: 'CreditCard', text: 'Split payment or corporate billing' },
  { icon: 'Star',     text: 'Custom menu selections and add-ons' },
  { icon: 'Truck',    text: 'Direct delivery to your office' },
];

export default function CorporateContactScreen({ onBack }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      className="text-center space-y-8 max-w-lg mx-auto py-8"
    >
      {/* Hero */}
      <div className="space-y-4">
        <div className="w-20 h-20 bg-blue-50 rounded-2xl flex items-center justify-center mx-auto">
          <SafeIcon name="Briefcase" className="text-blue-400 text-4xl" />
        </div>
        <h2 className="text-4xl font-serif text-charcoal">Corporate &amp; Workplace Orders</h2>
        <p className="text-sage-500 text-lg leading-relaxed">
          We offer dedicated accounts for offices, teams, and recurring workplace meal programs.
          Reach out to get set up — we'll tailor a plan that works for your team.
        </p>
      </div>

      {/* Perks card */}
      <div className="bg-white rounded-3xl border border-sage-100 p-8 shadow-soft space-y-5 text-left">
        <h3 className="font-serif text-xl text-charcoal">What you get</h3>
        <ul className="space-y-4">
          {PERKS.map(({ icon, text }) => (
            <li key={text} className="flex items-center gap-3">
              <div className="w-9 h-9 bg-blue-50 rounded-full flex items-center justify-center shrink-0">
                <SafeIcon name={icon} className="text-blue-400 text-sm" />
              </div>
              <span className="text-sm text-charcoal font-medium">{text}</span>
            </li>
          ))}
        </ul>
      </div>

      {/* CTA */}
      <div className="space-y-4">
        <h3 className="font-serif text-xl text-charcoal">Ready to get started?</h3>
        <p className="text-sage-500 text-sm">
          Reach out and we'll have your account set up within 1 business day.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <a
            href="mailto:orders@phoenixkabob.com?subject=Corporate Account Inquiry"
            className="btn-primary flex items-center justify-center gap-2"
          >
            <SafeIcon name="Mail" />
            Email Us
          </a>
          <a
            href="tel:+16025550000"
            className="btn-secondary flex items-center justify-center gap-2"
          >
            <SafeIcon name="Phone" />
            Call Us
          </a>
        </div>
      </div>

      {/* Back link */}
      <button
        onClick={onBack}
        className="text-sage-400 hover:text-sage-600 text-sm font-bold flex items-center gap-1.5 mx-auto transition-colors"
      >
        <SafeIcon name="ArrowLeft" />
        Back to Order Types
      </button>
    </motion.div>
  );
}
